import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Resource } from "../../types"
import { PAGE_SIZE, RESOURCE_TYPOLOGIES } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Resource>()

export function TableResources({
  resources,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  resources: Resource[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!resources) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [resources, count])

  return (
    <Table
      data={resources}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Titolo"
        name="title"
        sortable
        width="minmax(400px, 1fr)"
        render={(resource) => (
          <Link to={`/resources/resources/${resource.id}`}>
            <LinkMagik className="text-dark">{resource.title}</LinkMagik>
          </Link>
        )}
        stickyLeft
        // TODO badge
      />

      <Table.Column
      title="Tipologia"
        name="typology"
        sortable
        width={"minmax(200px, 1fr)"}
        render={(resource) => RESOURCE_TYPOLOGIES.find((opt) => opt.value === resource.typology)?.label || "-"}
      />
      

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} risorse
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
